import { loadTokens, saveTokens } from './tokenStore.js';
import { refreshAccessToken } from './oauth.js';

const EXPIRY_BUFFER_MS = 60 * 1000;

export async function getValidAccessToken(vaultKey) {
  const tokens = await loadTokens(vaultKey);
  if (!tokens) {
    throw new Error('No OAuth tokens found. Connect YouTube first.');
  }

  const expiresAt = tokens.expires_at ? new Date(tokens.expires_at).getTime() : 0;
  const isExpired = !expiresAt || Date.now() > expiresAt - EXPIRY_BUFFER_MS;

  if (!isExpired && tokens.access_token) {
    return tokens.access_token;
  }

  if (!tokens.refresh_token) {
    throw new Error('Refresh token missing. Reconnect YouTube.');
  }

  const refreshed = await refreshAccessToken({
    refreshToken: tokens.refresh_token,
    vaultKey
  });

  return refreshed.access_token;
}

export async function getTokenStatus(vaultKey) {
  const tokens = await loadTokens(vaultKey);
  if (!tokens) {
    return { status: 'missing' };
  }

  const expiresAt = tokens.expires_at ? new Date(tokens.expires_at).getTime() : 0;
  const expiresInMs = expiresAt ? expiresAt - Date.now() : 0;
  return {
    status: 'available',
    hasRefresh: Boolean(tokens.refresh_token),
    expiresAt: tokens.expires_at || null,
    expiresInMs
  };
}

export async function storeTokens(vaultKey, tokens) {
  await saveTokens(vaultKey, tokens);
}
